export function getTestID(title: string, postfix: string): string {
  try {
    return title.replace(/\s/g, '-') + postfix
  } catch (e) {
    return 'testId'
  }
}
